import { APP } from 'src/app/config/app';
import { IScheduleDay, IScheduleWeek } from 'src/app/models';

export function startOfDay(date: Date): Date {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);
  return day;
}

export function addDays(date: Date, days: number): Date {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
}

export function shiftPeriods(date: Date, periods: number, weekMode: boolean): Date {
  return addDays(date, periods * (weekMode ? 7 : 1));
}

export function weekdayFromMonday(date: Date): number {
  return (date.getDay() + 6) % 7;
}

export function daysBetween(from: Date, to: Date): number {
  return Math.round((to.getTime() - from.getTime()) / (APP.MINUTES_PER_DAY * 60000));
}

export function formatWeekday(date: Date, locale?: string): string {
  const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${date.getDate()}`;
}

export function buildScheduleDays(start: Date, end: Date | undefined, loadedPeriods: number, locale?: string): IScheduleDay[] {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' });
  const count = end ? Math.max(1, daysBetween(start, end) + 1) : loadedPeriods;
  return Array.from({ length: count }, (_, index) => {
    const date = addDays(start, index);
    return { date, label: formatter.format(date).replace(',', '') };
  });
}

export function buildScheduleWeeks(start: Date, end: Date | undefined, loadedPeriods: number, locale?: string): IScheduleWeek[] {
  const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
  const firstMonday = addDays(start, -weekdayFromMonday(start));
  const count = end ? Math.max(1, Math.floor(daysBetween(firstMonday, end) / 7) + 1) : loadedPeriods;
  return Array.from({ length: count }, (_, index) => {
    const startDate = addDays(firstMonday, index * 7);
    return { startDate, label: `${formatter.format(startDate)} - ${formatter.format(addDays(startDate, 6))}` };
  });
}
